// extracted by mini-css-extract-plugin
export default {"ldsfacebook":"MiniSpinner_ldsfacebook__BNuVA","lds-facebook":"MiniSpinner_lds-facebook__wXV7v"};